<template>
  <div class="relative" ref="containerRef">
    <div class="icon-search-mobile" @click="open">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
        <path
          d="M14.7955 15.911L20 21.4917M17 10.1989C17 14.6538 13.6421 18.2652 9.5 18.2652C5.35786 18.2652 2 14.6538 2 10.1989C2 5.744 5.35786 2.1326 9.5 2.1326C13.6421 2.1326 17 5.744 17 10.1989Z"
          stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div
      class="search-section"
      :class="{ active: keyword.trim() !== '' }"
      ref="searchSectionRef"
      v-if="isOpen || isLargeDesktop"
    >
      <input
        type="text"
        placeholder="Search"
        @keyup.enter="onSubmitSearch"
        @focusin="onChangeSearch"
        @input="onChangeSearch"
        @change="onChangeSearch"
        v-model="keyword"
      />
      <button class="submit-search" @click="onSubmitSearch">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
          <path
            d="M14.7955 15.911L20 21.4917M17 10.1989C17 14.6538 13.6421 18.2652 9.5 18.2652C5.35786 18.2652 2 14.6538 2 10.1989C2 5.744 5.35786 2.1326 9.5 2.1326C13.6421 2.1326 17 5.744 17 10.1989Z"
            stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <SearchPopup
        v-if="keyword.trim() !== ''"
        :show="isShow"
        :isError="error"
        :results="data"
        @viewAll="handleViewAll"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import SearchPopup from '~/components/SearchPopup/SearchPopup.vue';
import {onClickOutside} from '@vueuse/core';
import { useRoute } from 'vue-router';
const { query } = useRoute();
const { isLargeDesktop } = useBreakpoints();

const searchParam = query.search;
const keyword = ref('');
const error = ref(false);
const isShow = ref(true);
const isOpen = ref(false);
const containerRef = ref<HTMLElement | null>(null);

const { topSearchWithKeyword, data } = useSearchProduct(keyword.value as string, 1 , 5 , {});

if(keyword.value) {
  await topSearchWithKeyword(keyword.value as string, 1 , 5 , {});
}

function onSubmitSearch() {
  if (keyword.value.trim() !== '') {
    handleViewAll()
  }
}

async function onChangeSearch() {
  if(keyword.value && keyword.value.length > 2) {
    isShow.value = false;
    await topSearchWithKeyword(keyword.value as string, 1 , 5 , {});
    isShow.value = true;
  }
}

function handleViewAll() {
  const encoded = encodeURIComponent(keyword.value.trim());
  window.location.href = `/search?search=${encoded}`
}

function open() {
  isOpen.value = !isOpen.value
}

if (searchParam) {
  keyword.value = searchParam;
  isShow.value = false;
  isOpen.value = false;
}

onClickOutside(containerRef, () => {
  keyword.value = ''
  isOpen.value = false
})
</script>
